import { apiClient } from '../core/api/apiClient';

export interface LoginResponse {
  user: string;
  role: string;
  uid?: string;
}

export const authService = {
  googleLogin: async (credential: string): Promise<LoginResponse> => {
    return apiClient<LoginResponse>('/auth/google', {
      method: 'POST',
      body: JSON.stringify({ credential }),
    });
  },

  requestOtp: async (email: string): Promise<{ message: string }> => {
    return apiClient<{ message: string }>('/auth/otp/request', {
      method: 'POST',
      body: JSON.stringify({ email }),
    });
  },

  verifyOtp: async (email: string, otp: string): Promise<LoginResponse> => {
    return apiClient<LoginResponse>('/auth/otp/verify', {
      method: 'POST',
      body: JSON.stringify({ email, otp }),
    });
  },

  logout: async (): Promise<void> => {
    return apiClient<void>('/auth/logout', {
      method: 'POST',
    });
  },

  listUsers: async (): Promise<{ users: any[] }> => {
    return apiClient<{ users: any[] }>('/auth/admin/users', {
      method: 'GET',
    });
  },

  addUser: async (email: string, role: string, name: string): Promise<{ message: string }> => {
    return apiClient<{ message: string }>('/auth/admin/users', {
      method: 'POST',
      body: JSON.stringify({ email, role, name }),
    });
  },

  forceLogoutUser: async (email: string): Promise<{ message: string }> => {
    return apiClient<{ message: string }>(`/auth/admin/users/${encodeURIComponent(email)}/force_logout`, {
      method: 'POST',
    });
  },

  getUsageSummary: async (startDate?: string, endDate?: string): Promise<{ users: any[] }> => {
    const params: any = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    return apiClient<{ users: any[] }>('/auth/admin/usage', {
      method: 'GET',
      params,
    });
  },

  getUserUsage: async (email: string, startDate?: string, endDate?: string): Promise<any> => {
    const params: any = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    return apiClient<any>(`/auth/admin/usage/${encodeURIComponent(email)}`, {
      method: 'GET',
      params,
    });
  },

  getUsageByFeature: async (startDate?: string, endDate?: string): Promise<{ features: any[] }> => {
    const params: any = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    return apiClient<{ features: any[] }>('/auth/admin/usage/by-feature', {
      method: 'GET',
      params,
    });
  },
};
